;(function() {
  'use strict'

  angular.module('app.core').factory('quotaCellStateService', Factory)

  var States = {
    UNLIMITED: 'UNLIMITED',
    CLOSED: 'CLOSED',
    OVER: 'OVER',
    FULL: 'FULL',
    OPEN: 'OPEN',
  }

  /* @ngInject */
  function Factory() {
    return {
      States: States,
      getState: getState,
      getFillPercent: getFillPercent,
      getRemaining: getRemaining,
      hasBar: hasBar,
    }

    function getState(target, achieved) {
      if (!_.isNumber(target)) return States.UNLIMITED
      if (target === 0) return States.CLOSED

      achieved = _.isNumber(achieved) ? achieved : 0

      if (achieved > target) return States.OVER
      if (achieved >= target) return States.FULL

      return States.OPEN
    }

    function hasBar(target) {
      return _.isNumber(target)
    }

    function getFillPercent(target, achieved) {
      if (!_.isNumber(target)) return 0

      achieved = _.isNumber(achieved) ? achieved : 0

      // a closed cell has no ratio to draw, so it fills the bar rather than leaving it empty
      if (target === 0) return 100

      return Math.min(100, Math.round((achieved / target) * 100))
    }

    function getRemaining(target, achieved) {
      if (!_.isNumber(target)) return null

      achieved = _.isNumber(achieved) ? achieved : 0

      return Math.max(target - achieved, 0)
    }
  }
})()
